const fileTypes = {
  googleDrive: [`GoogleDriveFile`, `GoogleDriveAttachment`, `GoogleDriveUploadedFile`],
  dropbox: [`DropboxFile`, `DropboxAttachment`, `DropboxUploadedFile`],
  local: [`LocalFile`, `LocalAttachment`, `LocalUploadedFile`],
  warehouse: [`WarehouseFile`, `WarehouseAttachment`, `WarehouseUploadedFile`],
};

export const isDropboxFile = (type) => {
  return fileTypes.dropbox.some((value) => value === type);
};

export const isGoogleDriveFile = (type) => {
  return fileTypes.googleDrive.some((value) => value === type);
};

export const isLocalFile = (type) => {
  return fileTypes.local.some((value) => value === type);
};

export const isWarehouseFile = (type) => {
  return fileTypes.warehouse.some((value) => value === type);
};

export const isAttachmentFile = (type) => {
  return /Attachment$/i.test(type);
};

export const separateFileNameAndExtension = (name) => {
  const fileName = name.replace(/\.[^/.]+$/, "");
  const extension = `.${name.split(".").pop()}`;
  return { fileName, extension };
};

export const removeExtensionFromFileName = (name, extension) => {
  return extension && extension.length > 0 ? name.slice(0, -extension?.length - 1) : name;
};
